import * as React from 'react';
import { alpha, Badge, IconButton } from "@mui/material";
import { useState } from 'react';
import NotificationsIcon from '@mui/icons-material/Notifications';

export const Notifications = () => {
    const [open, setOpen] = useState(false);
    const totalUnRead = 0;
    const handleOpen = () => setOpen(o => !o);
    return (
        <IconButton
            size="large"
            //color={open ? 'primary' : 'default'}
            //color={open ? 'info' : 'info'}

            onClick={handleOpen} 
            sx={{
                ...(open && {
                    bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity)
                }),
                color: open ? '#006f98' : '#EDEFF0'
            }}
        >
            <Badge badgeContent={totalUnRead} color="error">
                <NotificationsIcon width={20} height={20} />
            </Badge>
        </IconButton>
    );
};
